import {getParamsFromString} from "./index";
import {set} from "object-path-immutable";
import asyncForEach from "../../../Utils/Form/FormDynamic/Utils/asyncForEach";
import request from "../../../Services/API/Requests";
import {isEqual} from "lodash";

function paramFormatter(params = []) {
    let newParams = {};
    params.forEach(param => {
        if (!param.tag) {
            newParams._value = param.value
        } else {
            newParams[param.tag] = param.value
        }
    });
    return newParams;
}

function paramGetter({action, globalValues, screenName}) {
    const params = paramFormatter(action.param);
    let finalValue = {};

    if (action.paramType === 'script') {
        return getParamsFromString(action.script, globalValues, screenName);
    }

    function setValue(currentParam) {
        return getParamsFromString(currentParam, globalValues, screenName);
    }

    //mapping param keys
    for (let key of Object.keys(params)) {
        if (params[key]) {
            if (key === '_value') {
                //collect array, if params more than 1
                if (params[key].length > 1) {
                    finalValue = [];
                    for (let currentParam of params[key]) {
                        finalValue.push(setValue(currentParam))
                    }
                } else {
                    finalValue = setValue(params[key][0])
                }
            } else {
                if (params[key].length > 1) {
                    finalValue[key] = [];
                    for (let currentParam of params[key]) {
                        finalValue[key].push(setValue(currentParam))
                    }
                } else {
                    finalValue[key] = setValue(params[key][0])
                }
            }
        }
    }
    return finalValue;
}

function multiLanguageValue(value, userLanguage) {
    if (!value) return '';

    if (Array.isArray(value)) return value;

    if (typeof value === 'object') {
        if (value[userLanguage]) return value[userLanguage];
        return value[Object.keys(value).find(v => value[v] !== undefined)]
    }

    return value;
}

async function getFileByObjUrl(url, readyFile) {
    return await fetch(url)
        .then(r => r.blob())
        .then(async blobFile => {
            let file = {};
            let reader = new FileReader();
            reader.readAsDataURL(blobFile);
            await new Promise(resolve => {
                reader.onload = () => {
                    file = {
                        name: readyFile.name,
                        type: readyFile.type,
                        content: reader.result,
                        refId: readyFile.refId,
                        refEntity: readyFile.refEntity,
                        sharedWith: readyFile.sharedWith,
                        signedBy: readyFile.signedBy
                    };
                    resolve();
                }
            })
            return file
        })
}

async function checkForFilesInObject(globalValues, uploadedLinks, screenName) {
    try {
        const links = uploadedLinks[screenName];
        const hasLinks = links && links.length;
        if (!hasLinks) return globalValues;
        let newGlobalValues = globalValues;
        await asyncForEach(links, async link => {
            const removedDots = link.replace(/\.(\d+)\./g, "[$1].")
            const fileObject = getParamsFromString(`{${removedDots}}`, globalValues, screenName);
            if (!fileObject || fileObject === 'undefined') return;
            if (Array.isArray(fileObject)) {
                let newFiles = [];
                await asyncForEach(fileObject, async file => {
                    const fileContent = await getFileByObjUrl(file.content, file);
                    newFiles.push(fileContent);
                })
                newGlobalValues = set(newGlobalValues, `param.${screenName}.${link}`, newFiles);
                return
            }

            newGlobalValues = set(newGlobalValues, `param.${screenName}.${link}`, await getFileByObjUrl(fileObject.content, fileObject))
        })
        return newGlobalValues
    } catch (e) {
        console.log('Check for files in object error', e)
    }
}

function getFileTypesByAssociation(types, file = {}) {
    const {name = ''} = file;
    const assocType = types.find(type => {
        if (type.association) {
            return type.association.find(assoc => {
                return name.toLowerCase().includes(assoc.toLowerCase())
            })
        }
    })
    return assocType ? assocType : {id: "system"}
}

function scrollToElement(element, scrollContainer = 'rootPaper') {
    setTimeout(() => {
        let block = document.getElementById(element);
        if (block) {
            let blockOffset = block.getBoundingClientRect().top;
            //let blockHeight = block.getBoundingClientRect().height;
            // console.log(blockOffset, block.getBoundingClientRect().bottom)
            //let headerElementHeight = document.getElementById('headerElement').getBoundingClientRect().height;
            let wrapper = document.getElementById(scrollContainer);
            const offsetCustomBlock = scrollContainer === 'rootPaper' ? 0 : 110;
            // let count = block.offsetTop - (wrapper.scrollTop + offsetCustomBlock);
            let count = blockOffset - 67 - offsetCustomBlock;
            wrapper.scrollBy({top: count, left: 0, behavior: 'smooth'})
        }
    }, 50)
}

function returnListProps(listId, lists, listUncheckAll) {
    if (lists && listId) {
        const keys = Object.keys(lists);
        const obj = {};

        function getAdvancedFilter() {
            return {
                value: this.advancedFilter,
                byId: (id) => {
                    const filtered = this.advancedFilter.find((f) => f.field === id) || {};
                    return {
                        value: filtered.value,
                        operand: filtered.operand,
                        field: filtered.field,
                        all: filtered,
                    };
                },
            };
        }

        function getPrevAdvancedFilter() {
            if (this.prevListState.advancedFilter && this.prevListState.advancedFilter) {
                return {
                    value: this.prevListState.advancedFilter,
                    byId: (id) => {
                        const filtered = this.prevListState.advancedFilter.find((f) => f.field === id) || {};
                        return {
                            value: filtered.value,
                            operand: filtered.operand,
                            field: filtered.field,
                            all: filtered,
                        };
                    }
                }
            }
            return null;
        }

        function getCheckedData() {
            return {
                value: this.checkedData,
                byField: (field) => {
                    return this.checkedData.map(d => d[field])
                },
            }
        }

        for (let key of keys) {
            let propType = lists[key];
            const listKeys = Object.keys(propType);
            for (let listKey of listKeys) {
                obj[listKey] = {
                    ...(obj[listKey] || {}),
                    [key]: lists[key][listKey],
                    _listName: listKey,
                    getAdvancedFilter: getAdvancedFilter,
                    getPrevAdvancedFilter: getPrevAdvancedFilter,
                    getCheckedData: getCheckedData,
                    uncheckAll: () => listUncheckAll(listId)
                };
            }
        }
        return obj[listId]
    }
}

async function loginSystem({username, password}, fetchApplication, nextScreen, setSidebarState, setSessionStorage) {
    try {
        const response = await request({
            url: "user/login",
            data: {
                username,
                password
            }
        });
        setSidebarState(true);
        setSessionStorage('user', response);
        fetchApplication(response.application.id);
        let nextUrl = `//${response.application.id}`;

        // const comeFrom = sessionStorage.getItem('comeFrom');
        // const lastComeFrom = sessionStorage.getItem('lastComeFrom');
        //
        // if (comeFrom && lastComeFrom !== comeFrom) {
        //     nextUrl = "//" + comeFrom;
        //     sessionStorage.setItem("lastComeFrom", comeFrom);
        // }

        nextScreen({destination: nextUrl});
        sessionStorage.removeItem("comeFrom")

    } catch (e) {
        throw e;
    }
}

function cacheScreens(env, application, newScreen) {

    if (!newScreen.id) return;

    const appCache = localStorage.getItem("screen-cache") ? JSON.parse(localStorage.getItem("screen-cache")) : {};
    const appEnv = appCache[env] || {};
    const envCaches = appEnv[application] || {};

    localStorage.setItem("screen-cache", JSON.stringify({
        ...appCache,
        [env]: {
            ...appEnv,
            [application]: {
                ...envCaches,
                [newScreen.id]: newScreen,
            },
        },

    }))
}

function getScreenFromCache(env, application, screenId) {
    const screenCache = localStorage.getItem('screen-cache') ? JSON.parse(localStorage.getItem('screen-cache')) : null;

    if (!screenCache) return null;

    try {
        const cachedScreen = screenCache[env][application][screenId];

        if (!cachedScreen) return null;

        return cachedScreen;
    } catch (e) {
        return null;
    }

}

function generateFunctionReference(uniqId = "", eventName) {
    return `${uniqId.split('.').join('_')}_${eventName}`
}

function queryParamsToJson(url) {
    let params = new URL(url).searchParams;
    let json = {};

    params.forEach((value, key) => {
        json[key] = value;
    });

    return json;
}

function shortcutCombinationMatcher(e, shortcut, callBack) {
    if (shortcut) {
        const combKeys = {
            ctrlKey: e.ctrlKey,
            altKey: e.altKey,
            shiftKey: e.shiftKey,
            key: e.key
        }
        if (isEqual(combKeys, shortcut)) {
            e.preventDefault();
            e.stopPropagation();
            callBack && callBack()
            return true
        }
    }

    return false;
}

export {
    paramFormatter,
    paramGetter,
    multiLanguageValue,
    getFileByObjUrl,
    getFileTypesByAssociation,
    checkForFilesInObject,
    scrollToElement,
    returnListProps,
    loginSystem,
    cacheScreens,
    getScreenFromCache,
    generateFunctionReference,
    queryParamsToJson,
    shortcutCombinationMatcher
}